module.exports = __webpack_public_path__ + "img/625.575f4800.png";